import { InsuranceType, MainPath } from "Constants/constants";

import { StyledAlert } from "App/global-style";
import { useTexts } from "Components/TextContext";
import { usePartnerId } from "Store/partners/partnerHooks";
import React from "react";

export const AddressSameAsHomeAddressAlert = (): React.ReactElement => {
  const { getText } = useTexts();
  const partnerId = usePartnerId();
  return (
    <StyledAlert
      title={getText(
        "akahousecontentsform.alerttitle.addresssameashomeaddress",
      )}
      description={getText(
        "akahousecontentsform.alertdescription.addresssameashomeaddress",
      )}
    >
      <a
        href={`/${MainPath.CHECK_PRICE}/${InsuranceType.HOUSE_CONTENTS}?grp=${partnerId}`}
      >
        {getText("akahousecontentsform.link.addresssameashomeaddress")}
      </a>
    </StyledAlert>
  );
};
